export default {
    en: {
        CONFIRMATION_DIALOG_CONFIRM: 'Confirm',
        CONFIRMATION_DIALOG_CANCEL: 'Cancel',
        LEVEL_ENTRY_TITLE: '{prefix}: {suffix}',
        LEVEL_ENTRY_DIALOG_START: 'Start',
        LEVEL_ENTRY_DIALOG_BACK: 'Back',
        SUBMISSION_DIALOG_TITLE_STARS: '{n} Star Earned!|{n} Stars Earned!',
        SUBMISSION_DIALOG_TITLE_STARS_LEVEL_COMPLETE: '{n} Star Earned -- {level} Complete!|{n} Stars Earned -- {level} Complete!',
        SUBMISSION_DIALOG_TITLE_INCORRECT: "That's Incorrect",
        SUBMISSION_DIALOG_TITLE_CORRECT: "That's Correct!",
        SUBMISSION_DIALOG_LEVEL_COMPLETED: "Congratulations! You've earned enough stars to complete {level}. You can continue practicing, or go back to the menu and try out another mission!",
        SUBMISSION_DIALOG_CONTINUE_LEVEL: "Continue {level}",
        SUBMISSION_DIALOG_NEXT: "Next",
        SUBMISSION_DIALOG_RETRY: "Retry",
        SUBMISSION_DIALOG_TITLE_EXHAUSTED: "All {level} Questions Completed!",
        SUBMISSION_DIALOG_EXHAUSTED_MESSAGE: "Great job! You've completed all available questions for this mission. Feel free to check out other missions! You can see your mission log or reset your progress from the profile menu.",
        SUBMISSION_DIALOG_BACK_TO_MENU: "Back to Menu",
        SUBMISSION_DIALOG_STAR_IMAGE_ALT: "{n} of {total} stars",
        SUBMISSION_DIALOG_LOADING_MESSAGE: "Thinking...",
        SUBMISSION_DIALOG_LOAD_START_ANNOUNCEMENT: "Started thinking.",
        SUBMISSION_DIALOG_LOAD_DONE_ANNOUNCEMENT: "Done thinking. Submission result: {title}",
        GAME_COMPLETED_DIALOG_TITLE: "You've Completed CyberSafeAI",
        GAME_COMPLETED_DIALOG_MESSAGE: "Amazing work! You've successfully completed all missions and sharpened your skills in identifying AI risks. Keep applying what you've learned to stay safe and think critically in the real world.",
        GAME_COMPLETED_DIALOG_CONFIRM: "Back to Menu",
        GAME_COMPLETED_DIALOG_RESET: "Restart",
        ERROR_COMPETITION_NOT_FOUND: "CyberSafe AI instance could not be found or no longer exists.",
        RESET_PROGRESS_DIALOG_TITLE: "Reset Progress",
        RESET_PROGRESS_DIALOG_MESSAGE: "Are you sure you want to reset your progress? This will reset all earned stars and progress, starting you from the beginning.",
        RESET_PROGRESS_DIALOG_ACKNOWLEDGEMENT: "I understand that I am resetting all of my progress.",
        RESET_PROGRESS_DIALOG_CONFIRM: "Reset",
        RESET_PROGRESS_DIALOG_CANCEL: "Cancel",
        RESET_PROGRESS_LOADING_DIALOG_MESSAGE: "Resetting progress...",
        RESET_PROGRESS_COMPLETE_DIALOG_TITLE: "Progress Reset Complete",
        RESET_PROGRESS_COMPLETE_DIALOG_MESSAGE: "All stars and progress have been successfully reset. Time to earn them all back!",
        RESET_PROGRESS_COMPLETE_DIALOG_CONFIRM: "Back to Menu"
    }
};
